import { render } from "./PdfRowMangel.vue?vue&type=template&id=2940a97a&scoped=true&ts=true"
import script from "./PdfRowMangel.vue?vue&type=script&lang=ts"
export * from "./PdfRowMangel.vue?vue&type=script&lang=ts"

import "./PdfRowMangel.vue?vue&type=style&index=0&id=2940a97a&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2940a97a"]])

export default __exports__